<button
  mat-icon-button
  [disabled]="disabled()"
  disableRipple
  [attr.aria-label]="'toggle ' + node()?.label"
  (click)="nodeToggle.emit()"
  class="arrow mr-1"
  type="button"
>
  <i class="vitamui-icon icon {{ expanded() ? 'vitamui-icon-chevron-down' : 'vitamui-icon-chevron-right' }}"></i>
</button>

<mat-checkbox
  id="enable{{ node()?.id }}"
  [checked]="node().checked"
  [(indeterminate)]="node().disabledChild"
  [disabled]="node().disabled"
  (change)="node().checked = $event.checked; onCheckboxClick()"
  (click)="onCheckboxClick()"
  [vitamuiTooltip]="node()?.title"
  [vitamuiTooltipShowDelay]="300"
>
  <span class="node-label hgap-1" [ngClass]="isVirtualNode() ? 'virtual' : ''" (click)="onLabelClick($event)">
    @if (isVirtualNode() || icon()) {
      <i class="vitamui-icon" [ngClass]="isVirtualNode() ? 'vitamui-icon-folder-full' : icon()"></i>
    }
    {{ node()?.title }}
  </span>
</mat-checkbox>
